// import { useEffect, useRef, useState } from 'react'
// import { useChat } from '../hooks/useChat'
// import Message from './Message'
// import ChatInput from './ChatInput'
// import Sidebar from './Sidebar'
// import { fetchSessionMessages } from '../api/client'

// export default function Chat({ context, onActivity }) {
//     const { messages, loading, send, clear, addGreeting, loadHistory } = useChat(context)
//     const [activeSessionId, setActiveSessionId] = useState(null)
//     const bottomRef = useRef(null)
//     const greetedRef = useRef(false)

//     // Runs once, on mount — greetedRef guards against re-injecting the
//     // greeting if context.greeting or addGreeting's reference ever changes.
//     useEffect(() => {
//         if (context.greeting && !greetedRef.current) {
//             addGreeting(context.greeting)
//             greetedRef.current = true
//         }
//     }, [context.greeting, addGreeting])

//     // Auto scroll
//     useEffect(() => {
//         bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
//     }, [messages])

//     const handleNewChat = () => {
//         setActiveSessionId(null)
//         clear()
//         if (context.greeting) addGreeting(context.greeting)
//     }

//     const handleLoadSession = async (sessionId) => {
//         if (sessionId === activeSessionId) return
//         setActiveSessionId(sessionId)

//         try {
//             const data = await fetchSessionMessages(sessionId, context.token)
//             // Convert DB messages to chat message format
//             const msgs = []
//             for (const m of data.messages) {
//                 if (m.query && m.query_type !== 'greeting') {
//                     msgs.push({ role: 'user', content: m.query })
//                 }
//                 if (m.answer) {
//                     msgs.push({
//                         role: 'assistant',
//                         content: m.answer,
//                         sql: m.generated_sql || null,
//                         chartConfig: m.chart_config || null,
//                         rowsSample: m.rows_sample || [],
//                         userQuery: m.query || '',
//                     })
//                 }
//             }
//             loadHistory(msgs, sessionId)
//         } catch (e) {
//             console.error('Failed to load session', e)
//         }
//     }

//     // Only a real, sent message counts as "activity" for idle/session-expiry
//     // tracking — not opening the panel, minimizing it, or loading history.
//     const handleSend = (query) => {
//         onActivity?.()
//         send(query)
//     }

//     return (
//         <div className="chat-layout">
//             <Sidebar
//                 context={context}
//                 onNewChat={handleNewChat}
//                 onLoadSession={handleLoadSession}
//                 activeSessionId={activeSessionId}
//             />

//             <main className="chat-main">
//                 <div className="chat-messages">
//                     {messages.length === 0 && (
//                         <div className="welcome">
//                             <div className="welcome-hint">Ask a question about your timesheet data</div>
//                         </div>
//                     )}
//                     {messages.map((msg, i) => (
//                         <Message key={i} msg={msg} context={{ ...context, activeSessionId: activeSessionId || context.sessionId }} />
//                     ))}
//                     <div ref={bottomRef} />
//                 </div>

//                 <div className="chat-footer">
//                     <ChatInput onSend={handleSend} loading={loading} />
//                     <div className="chat-disclaimer">
//                         MSR AI can make mistakes. Please double-check responses.
//                     </div>
//                 </div>
//             </main>
//         </div>
//     )
// }














import { useEffect, useRef, useState } from 'react'
import { useChat } from '../hooks/useChat'
import Message from './Message'
import ChatInput from './ChatInput'
import Sidebar from './Sidebar'
import { fetchSessionMessages } from '../api/client'

export default function Chat({ context, onActivity }) {
    // const { messages, loading, send, clear, addGreeting, loadHistory } = useChat(context)
    const { messages, loading, send, clear, addGreeting, loadHistory, sessionId, newSession } = useChat(context)
    const [activeSessionId, setActiveSessionId] = useState(null)
    const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0)
    const bottomRef = useRef(null)
    const greetedRef = useRef(false)
    const wasLoadingRef = useRef(false)

    // Runs once, on mount — greetedRef guards against re-injecting the
    // greeting if context.greeting or addGreeting's reference ever changes.
    useEffect(() => {
        if (context.greeting && !greetedRef.current) {
            addGreeting(context.greeting)
            greetedRef.current = true
        }
    }, [context.greeting, addGreeting])

    // Auto scroll
    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
    }, [messages])

    // Refresh the sidebar session list whenever a response finishes
    // (loading flips true -> false). This is what picks up the title
    // once it's generated on the backend after the 2nd real turn.
    useEffect(() => {
        if (wasLoadingRef.current && !loading) {
            setSidebarRefreshKey(prev => prev + 1)
        }
        wasLoadingRef.current = loading
    }, [loading])

    // const handleNewChat = () => {
    //     setActiveSessionId(null)
    //     clear()
    //     if (context.greeting) addGreeting(context.greeting)
    // }
    const handleNewChat = () => {
        newSession()
        setActiveSessionId(null)
        if (context.greeting) addGreeting(context.greeting)
    }

    const handleLoadSession = async (sessionId) => {
        if (sessionId === activeSessionId) return
        setActiveSessionId(sessionId)

        try {
            const data = await fetchSessionMessages(sessionId, context.token)
            // Convert DB messages to chat message format
            const msgs = []
            for (const m of data.messages) {
                if (m.query && m.query_type !== 'greeting') {
                    msgs.push({ role: 'user', content: m.query })
                }
                if (m.answer) {
                    msgs.push({
                        role: 'assistant',
                        content: m.answer,
                        sql: m.generated_sql || null,
                        chartConfig: m.chart_config || null,
                        rowsSample: m.rows_sample || [],
                        userQuery: m.query || '',
                    })
                }
            }
            loadHistory(msgs, sessionId)
        } catch (e) {
            console.error('Failed to load session', e)
        }
    }

    // If the session currently open gets deleted from the sidebar,
    // fall back to a fresh new chat rather than showing stale/dead history.
    // const handleSessionDeleted = (deletedSessionId) => {
    //     if (deletedSessionId === activeSessionId) {
    //         handleNewChat()
    //     }
    // }
    // const handleSessionDeleted = (deletedSessionId) => {
    //     const currentSessionId = activeSessionId || context.sessionId
    //     if (deletedSessionId === currentSessionId) {
    //         handleNewChat()
    //     }
    // }
    const handleSessionDeleted = (deletedSessionId) => {
        if (deletedSessionId === (activeSessionId || sessionId)) {
            handleNewChat()
        }
    }

    // Only a real, sent message counts as "activity" for idle/session-expiry
    // tracking — not opening the panel, minimizing it, or loading history.
    const handleSend = (query) => {
        onActivity?.()
        send(query)
    }

    return (
        <div className="chat-layout">
            <Sidebar
                context={context}
                onNewChat={handleNewChat}
                onLoadSession={handleLoadSession}
                onSessionDeleted={handleSessionDeleted}
                activeSessionId={activeSessionId}
                refreshKey={sidebarRefreshKey}
            />

            <main className="chat-main">
                <div className="chat-messages">
                    {messages.length === 0 && (
                        <div className="welcome">
                            <div className="welcome-hint">Ask a question about your timesheet data</div>
                        </div>
                    )}
                    {messages.map((msg, i) => (
                        <Message key={i} msg={msg} context={{ ...context, activeSessionId: activeSessionId || context.sessionId }} />
                    ))}
                    <div ref={bottomRef} />
                </div>

                <div className="chat-footer">
                    <ChatInput onSend={handleSend} loading={loading} />
                    <div className="chat-disclaimer">
                        MSR AI can make mistakes. Please double-check responses.
                    </div>
                </div>
            </main>
        </div>
    )
}






